import script from "./ForgetPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts&setup=true"

import "./ForgetPassword.vue?vue&type=style&index=0&id=61ba2f46&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ba2f46"]])

export default __exports__